import React, { useState } from 'react';
import classes from './checkDetail.module.scss';
import { renderModifiersRecursively } from '@containers/Fireboard/common';
import cn from 'classnames';
import ChevronIcon from '@assets/images/Fireboard/ChevronIcon';
import ClockIcon from '@assets/images/Fireboard/Clock';
import Discount from './Discount';
import constant from '@components/common/globalization';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';
import { safeJsonParse } from '@utility/helperFunction';

const CheckItems = props => {
  const { selectedItem, itemslist, currency, isExpanded, mode } = props;
  const [showModifiers, setShowModifiers] = useState(true);
  const storeInfo = safeJsonParse(window.sessionStorage.getItem('auth'), {});
  const renderModifiers = (mod, index) => {
    if (mod) {
      const modText =
        mod.quantity > 1
          ? `• ${mod.quantity} x ${mod.modifierName}`
          : `• ${mod.modifierName}`;
      return (
        <>
          <div
            key={index}
            className={cn(
              'row mx-0 col-12 py-1 pr-0 pt-2',
              classes.modifiersFont
            )}
          >
            {isExpanded && (
              <div className={cn('col-1', classes.emptySerialNumExtend)}></div>
            )}
            <div className={cn(' pl-2 pr-0', isExpanded ? 'col-6' : 'col-7')}>
              <em>{modText}</em>
            </div>
            <div className="col-2 px-2" />
            <div className="col-3 px-0 pr-1 text-right">
              <em>
                {currency}
                {mod?.price.toFixed(2)}
              </em>
            </div>
            {mod.note && (
              <div
                className={cn(
                  'px-2 ml-40 fw-400 text-truncate br-6',
                  isExpanded
                    ? classes.exapandedModNoteBorderMargin
                    : classes.modNoteBorderMargin
                )}
              >
                {mod.note}
              </div>
            )}
          </div>
        </>
      );
    }
    return <span />;
  };

  const HandleRenderModifiersRecursively = im =>
    renderModifiersRecursively(
      im,
      (i, index) => renderModifiers(i, index),
      i => {},
      true,
      0
    );

  const getseat = item => {
    const seats = selectedItem?.seats || [];
    const itemSeat = item?.seatIds?.[0];
    const seat = seats.find(s => s.id === itemSeat);
    const seatTag =
      seat?.number || seat?.name ? `S${seat?.number || seat?.name}` : 'T';
    return seatTag;
  };

  const getItemsCount = items => {
    const count = items
      ? items.reduce((total, item) => {
          if (item && !item.discountId) {
            total += item.quantity;
          }
          return total;
        }, 0)
      : 0;
    return count;
  };
  const ItemsConatinerHeight = {
    DEFAULT: { ActionbtnCount: 9 },
    ON_PREMISE: { ActionbtnCount: 8 },
    OFF_PREMISE: { ActionbtnCount: 9 },
    OFF_PREMISE_VENUE: { ActionbtnCount: 9 },
    TABLE_DELIVERY: { ActionbtnCount: 5 },
    FUTURE_ORDERS: { ActionbtnCount: 9 },
  };
  const renderDiscountAndServiceCharge = () => {
    const { discounts, serviceCharges } = selectedItem || {};
    const isDiscountNotEmpty = discounts && discounts.length > 0;
    const isServiceChgNotEmpty = serviceCharges && serviceCharges.length > 0;
    const showDiscountAndServiceChg =
      isDiscountNotEmpty || isServiceChgNotEmpty;
    if (!showDiscountAndServiceChg) return;
    return (
      <>
        {isDiscountNotEmpty &&
          discounts.map(discount => (
            <div className={isExpanded && 'col-10 px-0'} key={discount.id}>
              <Discount
                data={{ name: discount.discountName, price: discount.value }}
                currency={currency}
                seat={getseat(discount)}
                isExpanded={isExpanded}
              />
            </div>
          ))}
        {isServiceChgNotEmpty &&
          serviceCharges.map(sCharge => (
            <div className={isExpanded && 'col-10 px-0'} key={sCharge.id}>
              <Discount
                data={{ name: sCharge.serviceChargeName, price: sCharge.price }}
                currency={currency}
                seat={getseat(sCharge)}
              />
            </div>
          ))}
      </>
    );
  };
  const checkRepost = !storeInfo?.nonIntegratedPos;
  const ActionbtnCount = checkRepost
    ? Number(ItemsConatinerHeight[mode]?.ActionbtnCount ?? 0) + 1
    : ItemsConatinerHeight[mode]?.ActionbtnCount;
  
  return (
    <>
      {!isExpanded && (
        <div
          className={cn('col-12 px-0 d-flex pb-1 fw-500', classes.headerFont)}
        >
          <div className="col-10 px-0">{FLABEL().DETAILS_ITEMS}({getItemsCount(itemslist)})</div>
          <div
            className={cn('col-2 px-0 text-right', classes.chevronIcon)}
            onClick={() => setShowModifiers(!showModifiers)}
          >
            <ChevronIcon arrowUp={showModifiers} />
          </div>
        </div>
      )}
      <div
        className={cn(
          'col-12 px-0',
          isExpanded
            ? ActionbtnCount === 9
              ? classes.itemizedContainerExpanded9
              : ActionbtnCount > 9
              ? classes.itemizedContainerExpanded10
              : classes.itemizedContainerExpanded8
            : classes.itemizedContainer
        )}
      >
        {renderDiscountAndServiceCharge()}
        {itemslist && itemslist.length > 0 ? (
          itemslist.map((item, index) => {
            const seat = getseat(item);
            return (
              !item?.discountId && (
                <div
                  key={index}
                  className={cn('col-12 py-1 pr-1 pl-0')}
                >  <div  
                  key={index}
                  className={cn(
                    'row mx-0 px-0 py-0 flex-column',
                    !item.sent && classes.pendingItem,
                    isExpanded
                      ? `col-10 align-items-center ${classes.checkItemsFontExpanded} pr-3`
                      : `col-12 ${classes.CheckItemsFont}`
                  )}>
                  <div className="row mx-0 col-12 px-0">
                    <div className="col-1 px-0">
                      <div
                        className={cn(
                          isExpanded
                            ? classes.serialNumExtend
                            : classes.serialNum,
                          'mr-1'
                        )}
                      >
                        {seat}
                      </div>
                    </div>
                    <div
                      className={cn(
                        'col-6 pl-2 pr-0',
                        isExpanded && 'd-flex align-items-center'
                      )}
                    >
                      {item.menuItemName}
                    </div>
                    <div
                      className={cn(
                        'd-flex col-2 px-2',
                        isExpanded && 'align-items-center'
                      )}
                    >
                      <span>
                        {item.quantity > 0 ? `x ${item.quantity}` : ''}
                      </span>
                      {!item?.sentAt && (
                        <span className={cn('pl-1', classes.clockIcon)}>
                          <ClockIcon />
                        </span>
                      )}
                    </div>
                    <div
                      className={cn(
                        'col-3 px-0 text-right',
                        isExpanded &&
                          'd-flex align-items-center justify-content-end'
                      )}
                    >{`${currency}${item?.price?.toFixed(2)}`}</div>
                  </div>
                  {showModifiers && (
                    <>
                      <div
                        className={cn('row mx-0 w-100', isExpanded && 'pl-2')}
                      >
                        <div className={cn('col-7 p-0', classes.guestName)}>
                          <i>{item.guestName}</i>
                        </div>
                      </div>
                      <div
                        className={cn('row mx-0 w-100', isExpanded && 'pl-2')}
                      >
                        {item.note && (
                          <div
                            className={cn(
                              'px-2 text-truncate br-6',
                              isExpanded
                                ? classes.expandedBorderMargin
                                : classes.borderMargin
                            )}
                          >
                            {item.note}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                  {showModifiers && item.modifiers
                    ? HandleRenderModifiersRecursively(item)
                    : null}
                </div>
                </div>

              )
            );
          })
        ) : (
          <div
            className={cn(
              'row mx-0 col-12 h-90 justify-content-center align-items-center',
              classes.noItemFound
            )}
          >
            {constant.NO_ITEMS_FOUND}
          </div>
        )}
      </div>
    </>
  );
};

export default CheckItems;
